import React from 'react';

/////////////////// LAZY LOAD ////////////////////////////
import Loadable from 'react-loadable';
import Loading from './common_components/Loading';

const AsyncMain = Loadable({
  loader: () => import('./igroadmap_components/Main'),
  loading: Loading
});
//////////////////////////////////////////////////////////

export default class IgRoadmap extends React.Component {
  render() {
    return (
        <AsyncMain {...this.props} />
    );
  }
}
